import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom'
import styled from "styled-components";
import { Form, Input, Button, Select } from "antd";
import Swal from "sweetalert2";

import FormControl from "../../component/form/FormControl";
import MasterService from "../../service/_Master";
import Service from '../../service/Mgt-station'

import ReduxActions from "../../redux/actions";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const { Option } = Select;
const { TextArea } = Input;

const FormExtend = styled(FormControl)`
  .form-button {
    padding-left: 0;
    padding-right: 0;
  }

  &.column-2 {
    .ant-form-item.form-item__ip-address {
      width: 30% !important;

      @media only screen and (max-width: 450px){
        width: 70% !important;
        margin-right: 15px;
      }

      @media only screen and (max-width: 376px){
        width: 70% !important;
        margin-right: 5px;
      }
    }
    .ant-form-item.form-item__port {
      width: 18.5% !important;

      @media only screen and (max-width: 450px){
        width: 25% !important;
      }

      @media only screen and (max-width: 376px){
        width: 28% !important;
      }
    }
  }
  .ant-form-item.form-item__description {
    width: 100% !important;
    padding-right: 0px;
  }
`;

export default function FormAddStation(props) {

  const dispatch = useDispatch()
  const location = useSelector(state => state.mgtStation.currentLocation)
  const ug = useSelector(state => state.acc.group_id)
  const [selOrg, setSelOrg] = useState([])
  const [form] = Form.useForm()
  const [provinces, setProvinces] = useState([])
  const formData = useSelector(state => state.mgtStation.tempForm)

  useEffect(() => {
    const IntiData = async () => {
        setProvinces(await MasterService.getMasterProvince())
        if(formData){
            form.setFieldsValue({
                nameTh: formData.name_th || formData.nameTh,
                nameEn: formData.name_en || formData.nameEN,
                gpsLat: location.lat,
                gpsLong: location.lng,
                orgId: formData.org_id ? formData.org_id : null || formData.orgId ? formData.orgId : null,
                provinceId: formData.province_id || formData.provinceId,
                allowPublic: formData.allow_public ? 1 : 0 || formData.allowPublic ? 1 : 0,
                contactPerson: formData.contact_person || formData.contactPerson,
                simNumber: formData.sim_number || formData.simNumber,
                status: formData.status ? 1 : 0 || formData.status ? 1 : 0,
                ipAddress: formData.ip_address || formData.ipAddress,
                port: formData.port || formData.port,
                description: formData.description || formData.description,
            })
        }

        if(ug == 4){
          let orgs = await MasterService.getOrg();
          if(orgs) setSelOrg(orgs)
      }
    };

    IntiData()
  }, [form, location, formData, ug])


  const onFinish = async (values) => {
    values.gpsLat = parseFloat(values.gpsLat)
    values.gpsLong = parseFloat(values.gpsLong)

    if(props.stationId){
      let result = await Service.update(props.stationId, values)
      if(result){
        Swal.fire({
          title: "อัพเดทสถานีสำเร็จ",
          icon: "success",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        }).then(function() {
          window.location.href = `/mgt-station`
        })
      }
    }else{
      let result = await Service.create(values)
      if(result){
        Swal.fire({
          title: "สร้างสถานีสำเร็จ",
          icon: "success",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        }).then(function() {
          window.location.href = `/mgt-station`
        })
      }
    }
  };

  const onTriggerInputChange = () =>{
    let tempForm = form.getFieldValue()
    let data = {
      id: tempForm.id,
      province_id: tempForm.provinceId,
      name_th: tempForm.nameTh,
      name_en: tempForm.nameEn,
      description: tempForm.description,
      contact_person: tempForm.contactPerson,
      ip_address: tempForm.ipAddress,
      port: tempForm.port,
      sim_number: tempForm.simNumber,
      status: tempForm.status,
      allow_public: tempForm.allowPublic,
      org_id: tempForm.orgId
    }
    dispatch(ReduxActions.MgtStation.setTempForm(data))
  }

  const formInput = () => {
    return (
      <>{ug == 4 ? (
        <>
            <Form.Item
                name={["orgId"]}
                className="form-item__org-id"
                label="หน่วยงาน/องค์กร"
                rules={[{ required: true }]}
            >
                <Select placeholder="กรุณาเลือก" allowClear onChange={onTriggerInputChange}>
                    {selOrg.map((item) => (<Option key={item.id} value={item.id}>{item.disp_name}</Option>))};
                </Select>
            </Form.Item>
        </>
    ):(<></>)}
        <Form.Item
          name={["nameTh"]}
          className="form-item__name_th"
          label="ชื่อสถานีภาษาไทย"
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" onChange={onTriggerInputChange}/>
        </Form.Item>
        <Form.Item
          name={["nameEn"]}
          className="form-item__name_en"
          label="ชื่อสถานีภาษาอังกฤษ"
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" onChange={onTriggerInputChange}/>
        </Form.Item>
        <Form.Item
          name={["gpsLat"]}
          className="form-item__gps-lat"
          label="ละติจูด"
          rules={[{ required: true }]}
        >
          <Input
            autoComplete="off"
            onChange={(e) => {
              let value = e.target.value.replace(/[^0-9.]+/g, "");
              form.setFieldsValue({ gpsLat: value });
              props.fncSetLocation({lat: parseFloat(form.getFieldValue("gpsLat")) || 0, lng: parseFloat(form.getFieldValue("gpsLong"))})
              onTriggerInputChange()
            }}
          />
        </Form.Item>
        <Form.Item
          name={["gpsLong"]}
          className="form-item__gps-long"
          label="ลองจิจูด"
          rules={[{ required: true }]}
        >
          <Input
            autoComplete="off"
            onChange={(e) => {
              let value = e.target.value.replace(/[^0-9.]+/g, "");
              form.setFieldsValue({ gpsLong: value });
              props.fncSetLocation({lat: parseFloat(form.getFieldValue("gpsLat")) || 0, lng: parseFloat(form.getFieldValue("gpsLong"))})
              onTriggerInputChange()
            }}
          />
        </Form.Item>
        <Form.Item
          name={["provinceId"]}
          className="form-item__province-id"
          label="จังหวัดที่ตั้งสถานี"
          rules={[{ required: true }]}
        >
          <Select placeholder="กรุณาเลือก" allowClear onChange={onTriggerInputChange}>
            {provinces.map((item, index) => (
              <Option key={item.id} value={item.id}>
                {item.name_th}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name={["allowPublic"]}
          className="form-item__allowPublic"
          label="แสดงสาธารณะ"
          rules={[{ required: true }]}
        >
          <Select placeholder="กรุณาเลือก" allowClear onChange={onTriggerInputChange}>
            <Option value={1}>เปิดสาธารณะ</Option>
            <Option value={0}>ปิดสาธารณะ</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name={["contactPerson"]}
          className="form-item__contact-person"
          label="ชื่อผู้ดูแล"
        >
          <Input autoComplete="off"/>
        </Form.Item>
        <Form.Item
          name={["simNumber"]}
          className="form-item__simNumber"
          label="เบอร์โทรศัพท์สถานี"
        >
          <Input
            autoComplete="off"
            onChange={(e) => {
              let value = e.target.value.replace(/[^0-9]+/g, "");
              form.setFieldsValue({ contact_tel: value });
              onTriggerInputChange()
            }}
          />
        </Form.Item>
        <Form.Item
          name={["status"]}
          className="form-item__status"
          label="สถานะของสถานี"
          rules={[{ required: true }]}
        >
          <Select placeholder="กรุณาเลือก" allowClear onChange={onTriggerInputChange}>
            <Option value={1}>เปิดใช้งาน</Option>
            <Option value={0}>ปิดใช้งาน</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name={["ipAddress"]}
          className="form-item__ip-address"
          label="IP"
        >
          <Input
            autoComplete="off"
            onChange={(e) => {
              let value = e.target.value.replace(/[^0-9.]+/g, "");
              form.setFieldsValue({ ipAddress: value });
              onTriggerInputChange()
            }}
          />
        </Form.Item>
        <Form.Item
          name={["port"]}
          className="form-item__port"
          label="Port"
        >
          <Input
            autoComplete="off"
            onChange={(e) => {
              let value = e.target.value.replace(/[^0-9]+/g, "");
              form.setFieldsValue({ port: value });
              onTriggerInputChange()
            }}
          />
        </Form.Item>
        <Form.Item
          name={["description"]}
          className="form-item__description"
          label="หมายเหตุ"
        >
          <TextArea onChange={onTriggerInputChange}/>
        </Form.Item>
        <Form.Item className="form-button">
        {props.stationId ? 
        (props.permission.indexOf('update') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">อัพเดทสถานี</Button>) : (<></>))
        : 
        (props.permission.indexOf('create') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">สร้างสถานี</Button>) : (<></>))}
          <Button className="form-item__btn-cancel btn-secondary"><Link to="/mgt-station"> ยกเลิก</Link></Button>
        </Form.Item>
      </>
    );
  };

  return (
    <FormExtend
      name={"form-add-station"}
      column={2}
      inputs={formInput}
      onFinish={props.onFinish ? props.onFinish : onFinish}
      form={form}
      className={props.className ? props.className : ""}
    ></FormExtend>
  );
}
